var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`field-${_vm.field}`]},[_c('TSelectableGroup',{attrs:{"choices":_vm.choices,"error-messages":_vm.errors},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('FormErrorMessages',{staticClass:"my-3",attrs:{"error-messages":_vm.errors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }